/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * カフ値
 */
export type TreatmentAirwayManagementCuffValueTypeEnum =
  (typeof TreatmentAirwayManagementCuffValueTypeEnum)[keyof typeof TreatmentAirwayManagementCuffValueTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TreatmentAirwayManagementCuffValueTypeEnum = {
  NUMBER_10: '10',
  OTHER: 'OTHER',
} as const;
